<template>
    <div class="modal fade" id="newStockModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered  w-[600px] ">
            <div class="modal-content" v-if="props.selectedDetails">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">New Stock Request</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                     <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-1">
                        <div class="p-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100">
                            <h6 class="text-sm font-medium text-gray-500 dark:text-gray-400">Country</h6>
                            <p class="mt-1 text-lg font-semibold">{{ props.selectedDetails.country }}</p>
                        </div>
                        <div class="p-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100">
                            <h6 class="text-sm font-medium text-gray-500 dark:text-gray-400">ISP</h6>
                            <p class="mt-1 text-lg font-semibold">{{ props.selectedDetails.isp }}</p>
                        </div>
                        <div class="p-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100">
                            <h6 class="text-sm font-medium text-gray-500 dark:text-gray-400">State/City</h6>
                            <p class="mt-1 text-lg font-semibold">{{ props.selectedDetails.city }}</p>
                        </div>
                    </div>
                    <div class="w-1/2 float-left px-2 py-2 h-20 modal-item">
                        Max Quantity:
                        <v-text-field v-model="quantity" variant="outlined" density="compact" type="number" rounded="0"></v-text-field>
                    </div>
                    <div class="float-left w-1/2 px-2 py-2 h-20 modal-item">
                        How soon?
                        <v-text-field v-model="period" variant="outlined" density="compact" rounded="0"></v-text-field>
                    </div>
                    <div class="float-left w-full px-2 py-2 h-20 modal-item">
                        Telegram Contact:
                        <v-text-field v-model="contact" variant="outlined" density="compact" rounded="0"></v-text-field>
                    </div>
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button> -->
                    <button type="submit" :disabled="buttonDisableFlag" class="btn btn-primary" @click="handleRequest">Request</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, ref, watchEffect } from "vue"
import { useRouter } from 'vue-router';
import { useAlertStore, useAdminNewLocationStore } from "@/stores"

const adminNewLocationStore = useAdminNewLocationStore()
const alertStore = useAlertStore();

const props = defineProps({
    selectedDetails: {
        type: Object, // Assuming user object has a name property
        required: true
    }
});
const router = useRouter();

const quantity = ref(1);
const period = ref('');
const contact = ref('');
const buttonDisableFlag = ref(false)

const handleRequest = (() => {
    if(!contact.value) {
        alertStore.error("Input telegram contact.")
        return;
    }
    const requestData = {
        country: props.selectedDetails.country,
        isp: props.selectedDetails.isp,
        city: props.selectedDetails.city,
        period: period.value,
        contact: contact.value,
        quantity: quantity.value,
        type: 'Stock',
    };
    adminNewLocationStore.createNewLocation(requestData);
});

watchEffect(() => {
    quantity.value = Math.max(0, Math.floor(quantity.value))
}, [quantity.value])
</script>